import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      color: palette.text.primary,
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      maxWidth: '420px',
      flexGrow: 1,
      '@media (max-width: 768px)': {
        width: '100%',
        maxWidth: '100%'
      }
    },
    zone: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px'
    },
    buttons: {
      display: 'flex',
      justifyContent: 'space-between',
      height: '39px',
      '@media (max-width: 425px)': {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        gap: '5px',
        height: 'min-content'
      }
    },
    error: {
      color: palette.common.red
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
